import { FULL, CNTRY, POSTALCNTRY } from '../constants/billing-address-enums';
import isEmptyString from './is-empty-string';

const isMoreAddressInfoRequired = (fullBillingAddress, merchantBillingAddressConstraints) => {
  const { line1, postalCode, countryCode } = fullBillingAddress || {};
  switch (merchantBillingAddressConstraints) {
    case FULL:
      return !line1 || isEmptyString(line1);
    case CNTRY:
      return !countryCode;
    case POSTALCNTRY:
      return !postalCode;
    default:
      return false;
  }
};
export default isMoreAddressInfoRequired;
